<template>
	<div class="face-swap-page">
		<div class="page-header">
			<div class="action-area">
				<el-button size="small" type="primary" @click="createDialogVisible = true">
					<i class="el-icon-plus"></i> 创建换脸任务
				</el-button>
			</div>
		</div>
		<div class="table-container">
			<div class="task-card-list">
				<div v-for="item in mediakitList" :key="item.mediakitId" class="task-card">
					<div class="card-header">
						<div class="task-name">{{ item.mediakitName }}</div>
						<el-tag :type="item.mediakitOutContent ? 'success' : 'warning'" size="small">
							{{ item.mediakitOutContent ? '已完成' : '处理中' }}
						</el-tag>
					</div>
					<div class="card-body">
						<div class="media-row">
							<div class="media-item">
								<div class="media-label">源视频</div>
								<video :src="item.mediakitContent" controls class="media-preview video-preview" />
							</div>
							<div class="media-item">
								<div class="media-label">目标人物</div>
								<el-image :src="item.mediakitTargetContent" fit="cover" class="media-preview image-preview" />
							</div>
							<div class="media-item">
								<div class="media-label">结果视频</div>
								<template v-if="item.mediakitOutContent">
									<video :src="item.mediakitOutContent" controls class="media-preview video-preview" />
								</template>
								<div v-else class="media-empty">
									<i class="el-icon-loading"></i>
									<span>处理中...</span>
								</div>
							</div>
						</div>
						<div class="card-footer">
							<span class="create-time">创建时间: {{ item.mediakitAddTime }}</span>
							<div class="card-actions">
								<el-button size="mini" type="primary" @click="handleRefreshTask(item)" v-if="!item.mediakitOutContent">
									<i class="el-icon-refresh"></i> 刷新
								</el-button>
								<el-button size="mini" type="danger" @click="handleDelete(item)">
									<i class="el-icon-delete"></i> 删除
								</el-button>
							</div>
						</div>
					</div>
				</div>
				<div v-if="mediakitList.length === 0" class="empty-state">
					<i class="el-icon-video-camera"></i>
					<p>暂无换脸任务</p>
				</div>
			</div>
		</div>
		<div class="pagination-area">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
				:total="total" layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>
		<el-dialog :visible.sync="createDialogVisible" title="创建换脸任务" width="700px">
			<el-form :model="createForm" label-width="100px">
				<el-form-item label="任务名称">
					<el-input v-model="createForm.taskName" placeholder="请输入任务名称" maxlength="30" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="选择视频">
					<div class="upload-bar">
						<i class="el-icon-video-camera"></i>
						<span>{{ createForm.videoName || '未选择视频' }}</span>
						<el-dropdown trigger="click" @command="handleVideoCommand">
							<span class="upload-btn">
								<i class="el-icon-plus"></i>
								选择视频
								<i class="el-icon-arrow-down"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="upload">上传本地文件</el-dropdown-item>
								<el-dropdown-item command="library">选择素材库</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<div v-if="createForm.videoUrl" class="asset-preview-area">
						<video :src="createForm.videoUrl" controls style="width: 100%; max-height: 50%;" />
					</div>
				</el-form-item>
				<el-form-item label="选择人物">
					<div class="upload-bar">
						<i class="el-icon-user"></i>
						<span>{{ createForm.faceName || '未选择人物' }}</span>
						<el-dropdown trigger="click" @command="handleFaceCommand">
							<span class="upload-btn">
								<i class="el-icon-plus"></i>
								选择人物
								<i class="el-icon-arrow-down"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="upload">上传本地文件</el-dropdown-item>
								<el-dropdown-item command="library">选择素材库</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<div v-if="createForm.faceUrl" class="asset-preview-area">
						<el-image :src="createForm.faceUrl" fit="cover" style="width: 50%; max-height: 50%;" />
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleCancel">取消</el-button>
				<el-button type="primary" @click="handleSubmit" :loading="submitLoading">开始转换</el-button>
			</div>
		</el-dialog>

		<el-dialog title="选择素材" :visible.sync="materialDialogVisible" width="800px" @open="onMaterialDialogOpen">
			<div class="asset-filter-group" style="display: none;">
				<button class="filter-btn" :class="{ active: searchForm.type === '1' }"
					@click="searchForm.type = '1'; fetchAssetLibrary()">图片</button>
				<button class="filter-btn" :class="{ active: searchForm.type === '4' }"
					@click="searchForm.type = '4'; fetchAssetLibrary()">视频</button>
			</div>
			<div class="asset-library-list">
				<template v-if="assetLibraryData.length > 0">
					<div v-for="asset in assetLibraryData" :key="asset.resourceId" class="asset-item"
						@click="selectAssetFromLibrary(asset)">
						<div v-if="asset.resourceCate === 1" class="asset-preview">
							<img :src="asset.resourceUrl" :alt="asset.resourceName" style="width: 100%; max-height: 200px;">
						</div>
						<div v-else-if="asset.resourceCate === 4" class="asset-preview video-preview-item">
							<video :src="asset.resourceUrl" controls style="width: 100%; max-height: 200px;" />
						</div>
						<span class="asset-name">{{ asset.resourceName }}</span>
					</div>
				</template>
				<div v-else class="empty-state">
					<i class="el-icon-picture"></i>
					<p>暂无素材</p>
				</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="uploadDialogVisible" title="上传资产" width="500px">
			<el-form :model="uploadForm" label-width="100px">
				<el-form-item label="资产名称">
					<el-input v-model="uploadForm.resourceName" maxlength="50" show-word-limit placeholder="请输入资产名称"></el-input>
				</el-form-item>
				<el-form-item label="是否公开">
					<el-switch v-model="uploadForm.resourceType" active-text="公开" inactive-text="私有"></el-switch>
				</el-form-item>
				<el-form-item label="资产类型">
					<el-radio-group v-model="uploadForm.resourceCate">
						<el-radio label="1">形象</el-radio>
						<el-radio label="4">视频</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="素材性别">
					<el-radio-group v-model="uploadForm.resourceGender">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="0">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="素材上传">
					<el-upload :action="`${baseUrl}/resource/upload?token=${adminInfo.adminToken}`" :accept="getAcceptType()" :show-file-list="true"
						:file-list="uploadFileList" :on-success="handleFileUploadSuccess" :on-change="handleFileChange"
						:auto-upload="false" :limit="1" :on-exceed="handleExceed">
						<el-button size="small" type="primary">选择文件</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item label="素材备注">
					<el-input v-model="uploadForm.resourceRemark" type="textarea" placeholder="请输入备注信息"
						:rows="3"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="uploadDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitUploadAsset">确定上传</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	const BASE_URL = 'https://ai.boningnet.cn/api'

	export default {
		name: 'FaceSwap',
		data() {
			return {
				baseUrl: BASE_URL,
				createDialogVisible: false,
				materialDialogVisible: false,
				uploadDialogVisible: false,
				submitLoading: false,
				materialSelectType: '',
				assetLibraryData: [],
				searchForm: {
					type: ''
				},
				createForm: {
					taskName: '',
					videoUrl: '',
					videoName: '',
					faceUrl: '',
					faceName: ''
				},
				uploadForm: {
					resourceName: '',
					resourceType: true,
					resourceCate: '1',
					resourceGender: 1,
					resourceRemark: ''
				},
				uploadFileList: [],
				mediakitList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				taskId: '',
				pollingTimer: null,
				isPolling: false,
				pollingRetryCount: 0,
				maxRetryCount: 60,
				adminInfo: {}
			}
		},
		methods: {
			handleVideoCommand(command) {
				if (command === 'upload') {
					this.uploadForm.resourceCate = '4'
					this.uploadDialogVisible = true
				} else {
					this.materialSelectType = 'video'
					this.searchForm.type = '4'
					this.materialDialogVisible = true
				}
			},
			handleFaceCommand(command) {
				if (command === 'upload') {
					this.uploadForm.resourceCate = '1'
					this.uploadDialogVisible = true
				} else {
					this.materialSelectType = 'face'
					this.searchForm.type = '1'
					this.materialDialogVisible = true
				}
			},
			onMaterialDialogOpen() {
				this.fetchAssetLibrary()
			},
			async fetchAssetLibrary() {
				try {
					const params = {
						token: this.adminInfo.adminToken,
						pageNum: 1,
						pageCount: 99999,
						resourceCate: parseInt(this.searchForm.type)
					}
					if(this.adminInfo.adminLevel>0){
						params.adminId=this.adminInfo.adminId
					}
					const res = await axios.get(`${BASE_URL}/resource/list`, {
						params
					})
					if (res.data.length > 0) {
						this.assetLibraryData = res.data
					}
				} catch (error) {
					this.$message.error('加载素材失败')
				}
			},
			selectAssetFromLibrary(asset) {
				if (this.materialSelectType === 'video') {
					this.createForm.videoUrl = asset.resourceUrl
					this.createForm.videoName = asset.resourceName
				} else {
					this.createForm.faceUrl = asset.resourceUrl
					this.createForm.faceName = asset.resourceName
				}
				this.materialDialogVisible = false
			},
			async fetchMediakitList() {
				try {
					const params = {
						token: this.adminInfo.adminToken,
						pageNum: this.currentPage,
						pageCount: this.pageSize,
						mediakitType: 1
					};
					if (this.adminInfo.adminLevel > 0) {
						params.adminId = this.adminInfo.adminId
					}
					const res = await axios.get(`${BASE_URL}/media_kit/list`, {
						params
					})
					this.mediakitList = res.data
					if (res.data.length > 0) {
						this.total = res.data[0].allcount || 0
					}else{
						this.total = 0
					}
				} catch (error) {
					this.$message.error('加载任务列表失败')
				}
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.currentPage = 1
				this.fetchMediakitList()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchMediakitList()
			},
			getAcceptType() {
				switch (this.uploadForm.resourceCate) {
					case '1':
						return 'image/*'
					case '4':
						return 'video/*'
					default:
						return ''
				}
			},
			handleFileUploadSuccess(response) {
				if (response.resourceUrl) {
					this.$message.success('文件上传成功')
				}
			},
			handleFileChange(file, fileList) {
				if (file.status === 'ready') {
					this.uploadFileList = [file]
					if (!this.uploadForm.resourceName) {
						this.uploadForm.resourceName = file.name.replace(/\.[^/.]+$/, '')
					}
				} else if (file.status === 'removed') {
					this.uploadFileList = fileList
				}
			},
			handleExceed() {
				this.$message.warning('只能上传一个文件')
			},
			submitUploadAsset() {
				if (!this.uploadForm.resourceName) {
					this.$message.warning('请输入资产名称')
					return
				}
				if (!this.uploadFileList || !this.uploadFileList.length) {
					this.$message.warning('请选择要上传的文件')
					return
				}
				const file = this.uploadFileList[0].raw || this.uploadFileList[0]
				if (!file || !file.name) {
					this.$message.warning('请选择要上传的文件')
					return
				}
				let adminId = this.adminInfo.adminId 
				const formData = new FormData()
				formData.append('file', file)
				axios.post(`${BASE_URL}/resource/upload?token=${this.adminInfo.adminToken}`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(res => {
					const fileUrl = res.data.data.url
					if (this.uploadForm.resourceCate === '4') {
						this.createForm.videoUrl = fileUrl
						this.createForm.videoName = this.uploadForm.resourceName
					} else if (this.uploadForm.resourceCate === '1') {
						this.createForm.faceUrl = fileUrl
						this.createForm.faceName = this.uploadForm.resourceName
					}
					const addData = {
						resourceName: this.uploadForm.resourceName,
						resourceType: this.uploadForm.resourceType ? 1 : 0,
						resourceCate: parseInt(this.uploadForm.resourceCate),
						resourceUrl: fileUrl,
						resourceSize: file.size,
						resourceGender: this.uploadForm.resourceGender,
						resourceRemark: this.uploadForm.resourceRemark,
						adminId: adminId
					}
					axios.post(`${BASE_URL}/resource/add?token=${this.adminInfo.adminToken}`, addData).then(() => {
						this.uploadDialogVisible = false
						this.uploadForm = {
							resourceName: '',
							resourceType: 1,
							resourceCate: '1',
							resourceGender: 1,
							resourceRemark: ''
						}
						this.uploadFileList = []
						this.$message.success('上传成功')
					}).catch(() => {
						this.$message.error('添加资产失败')
					})
				}).catch(() => {
					this.$message.error('上传文件失败')
				})
			},
			handleDelete(row) {
				this.$confirm('确定要删除该任务吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					try {
						const res = await axios.get(`${BASE_URL}/media_kit/delete`, {
							params: {
								token: this.adminInfo.adminToken,
								mediakitId: row.mediakitId
							}
						})
						if (res.data === true) {
							this.$message.success('删除成功')
							this.fetchMediakitList()
						} else {
							this.$message.error(res.data.message || '删除失败')
						}
					} catch (error) {
						this.$message.error('删除失败')
					}
				}).catch(() => {
					this.$message.info('已取消删除')
				})
			},
			async handleRefreshTask(row) {
				try {
					const res = await axios.get(`${BASE_URL}/volcano_ark/mediakit_task_get`, {
						params: {
							token: this.adminInfo.adminToken,
							task_id: row.mediakitTaskid
						}
					})
					const data = res.data.data
					if (data.status === 'completed') {
						const videoUrl = data.result.video_url
						if (videoUrl) {
							await axios.post(`${BASE_URL}/media_kit/update?token=${this.adminInfo.adminToken}`, {
								mediakitId: row.mediakitId,
								mediakitTaskid: row.mediakitTaskid,
								mediakitName: row.mediakitName,
								mediakitContent: row.mediakitContent,
								mediakitTargetContent: row.mediakitTargetContent,
								mediakitOutContent: videoUrl
							})
							this.$message.success('任务刷新成功')
							this.fetchMediakitList()
						}
					} else if (data.status === 'failed' || data.status === 'error') {
						this.$message.error('任务处理失败')
					} else {
						this.$message.info('任务正在处理中...')
					}
				} catch (error) {
					this.$message.error('刷新任务失败')
				}
			},
			async handleSubmit() {
				if (!this.createForm.taskName) {
					this.$message.warning('请输入任务名称')
					return
				}
				if (!this.createForm.videoUrl) {
					this.$message.warning('请选择视频')
					return
				}
				if (!this.createForm.faceUrl) {
					this.$message.warning('请选择人物图片')
					return
				}
				this.submitLoading = true
				try {
					const requestBody = {
						video_url: this.createForm.videoUrl,
						face_mappings: [
							{
								target_face_url: this.createForm.faceUrl
							}
						]
					}
					const res = await axios.post(`${BASE_URL}/volcano_ark/face_swap_video?token=${this.adminInfo.adminToken}`, requestBody)
					if (res.data.code === 0) {
						this.taskId = res.data.data.task_id
						this.$message.success('任务创建成功')
						const addBody = {
							mediakitName: this.createForm.taskName,
							mediakitType: 1,
							mediakitTaskid: this.taskId,
							mediakitContent: this.createForm.videoUrl,
							mediakitTargetContent: this.createForm.faceUrl,
							mediakitOutContent: '',
							adminId: this.adminInfo.adminId
						}
						await axios.post(`${BASE_URL}/media_kit/add?token=${this.adminInfo.adminToken}`, addBody)
						this.createDialogVisible = false
						const taskName = this.createForm.taskName
						this.createForm = {
							taskName: '',
							videoUrl: '',
							videoName: '',
							faceUrl: '',
							faceName: ''
						}
						await this.fetchMediakitList()
						if (this.taskId) {
							const newTask = this.mediakitList.find(item => item.mediakitName === taskName)
							if (!newTask || !newTask.mediakitOutContent) {
								this.isPolling = true
								this.pollingRetryCount = 0
								this.$message.info('任务执行中，请稍候...')
								this.pollTaskStatus()
							}
						}
					} else {
						this.$message.error(res.data.message || '任务创建失败')
					}
				} catch (error) {
					this.$message.error('任务创建失败')
				} finally {
					this.submitLoading = false
				}
			},
			handleCancel() {
				this.createDialogVisible = false
				this.createForm = {
					taskName: '',
					videoUrl: '',
					videoName: '',
					faceUrl: '',
					faceName: ''
				}
			},
			async pollTaskStatus() {
				if (!this.taskId || !this.isPolling) return
				try {
					const res = await axios.get(`${BASE_URL}/volcano_ark/mediakit_task_get`, {
						params: {
							token: this.adminInfo.adminToken,
							task_id: this.taskId
						}
					})
					const data = res.data.data
					if (data.status === 'completed') {
						const videoUrl = data.result.video_url
						if (videoUrl) {
							const task = this.mediakitList.find(item => item.mediakitTaskid === this.taskId)
							if (task) {
								await axios.post(`${BASE_URL}/media_kit/update?token=${this.adminInfo.adminToken}`, {
									mediakitId: task.mediakitId,
									mediakitTaskid:this.taskId,
									mediakitName: task.mediakitName,
									mediakitContent: task.mediakitContent,
									mediakitTargetContent: task.mediakitTargetContent,
									mediakitOutContent: videoUrl
								})
							}
							this.$message.success('换脸处理完成')
						}
						this.isPolling = false
						this.fetchMediakitList()
					} else if (data.status === 'failed' || data.status === 'error') {
						this.isPolling = false
						this.$message.error('换脸处理失败')
					} else {
						this.pollingRetryCount++
						if (this.pollingRetryCount >= this.maxRetryCount) {
							this.isPolling = false
							this.$message.error('任务处理超时')
							return
						}
						this.pollingTimer = setTimeout(() => {
							this.pollTaskStatus()
						}, 10000)
					}
				} catch (error) {
					this.pollingRetryCount++
					if (this.pollingRetryCount >= this.maxRetryCount) {
						this.isPolling = false
						this.$message.error('任务查询超时')
						return
					}
					this.pollingTimer = setTimeout(() => {
						this.pollTaskStatus()
					}, 10000)
				}
			}
		},
		mounted() {
			this.adminInfo = JSON.parse(localStorage.getItem('adminInfo') || '{}')
			this.fetchMediakitList()
		},
		beforeDestroy() {
			if (this.pollingTimer) {
				clearTimeout(this.pollingTimer)
				this.pollingTimer = null
			}
		}
	}
</script>

<style scoped>
	.face-swap-page {
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 10px;
	}

	.page-header {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-bottom: 10px;
	}

	.action-area {
		display: flex;
		gap: 12px;
	}

	.table-container {
		flex: 1;
		overflow-y: auto;
	}

	.task-card-list {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
		gap: 20px;
	}

	.task-card {
		background-color: #fff;
		border-radius: 12px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		overflow: hidden;
		transition: transform 0.2s ease, box-shadow 0.2s ease;
	}

	.task-card:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 20px;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		color: #fff;
	}

	.task-name {
		font-size: 16px;
		font-weight: 600;
	}

	.card-body {
		padding: 20px;
	}

	.media-row {
		display: flex;
		gap: 16px;
		margin-bottom: 16px;
	}

	.media-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.media-label {
		font-size: 12px;
		color: #6b7280;
		font-weight: 500;
	}

	.media-preview {
		width: 100%;
		border-radius: 8px;
		background-color: #f9fafb;
	}

	.video-preview {
		max-height: 120px;
	}

	.image-preview {
		height: 120px;
	}

	.media-empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 120px;
		background-color: #f9fafb;
		border-radius: 8px;
		color: #9ca3af;
		gap: 8px;
	}

	.media-empty i {
		font-size: 24px;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}

	.card-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 16px;
		border-top: 1px solid #e5e7eb;
	}

	.create-time {
		font-size: 12px;
		color: #9ca3af;
	}

	.card-actions {
		display: flex;
		gap: 8px;
	}

	.pagination-area {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
		padding-top: 16px;
		border-top: 1px solid #e5e7eb;
	}

	.empty-state {
		grid-column: 1 / -1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 80px 0;
		color: #9ca3af;
	}

	.empty-state i {
		font-size: 64px;
		margin-bottom: 16px;
		color: #d1d5db;
	}

	.empty-state p {
		font-size: 16px;
	}

	.upload-bar {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 3px 4px;
		background-color: #f9fafb;
		border-radius: 8px;
		border: 1px solid #e5e7eb;
	}

	.upload-bar i {
		font-size: 16px;
		color: #6b7280;
	}

	.upload-bar span:first-of-type {
		flex: 1;
		font-size: 14px;
		color: #374151;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.upload-btn {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 1px 12px;
		background-color: #10b981;
		color: #fff;
		border-radius: 16px;
		font-size: 13px;
		cursor: pointer;
		transition: background-color 0.2s ease;
	}

	.upload-btn:hover {
		background-color: #10b981;
	}

	.asset-preview-area {
		margin-top: 16px;
		border-radius: 8px;
		overflow: hidden;
		background-color: #f9fafb;
		border: 1px solid #e5e7eb;
		max-height: 50%;
		width: 50%;
		overflow-y: auto;
		padding: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.hidden-input {
		display: none;
	}

	.asset-filter-group {
		display: flex;
		gap: 8px;
		margin-bottom: 16px;
		padding-bottom: 16px;
		border-bottom: 1px solid #e5e7eb;
	}

	.filter-btn {
		padding: 6px 16px;
		border: 1px solid #d1d5db;
		border-radius: 4px;
		background-color: #fff;
		cursor: pointer;
		font-size: 14px;
		color: #6b7280;
		transition: all 0.2s;
	}

	.filter-btn:hover {
		border-color: #4f46e5;
		color: #4f46e5;
	}

	.filter-btn.active {
		background-color: #4f46e5;
		color: #fff;
		border-color: #4f46e5;
	}

	.asset-library-list {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		max-height: 400px;
		overflow-y: auto;
		padding: 12px 0;
	}

	.asset-item {
		width: calc(25% - 10px);
		cursor: pointer;
		text-align: center;
	}

	.asset-preview {
		width: 100%;
		height: 80px;
		border-radius: 8px;
		overflow: hidden;
		background-color: #f5f5f5;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.asset-preview img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.video-preview-item {
		background-color: #1f2937;
	}

	.video-preview-item video {
		width: 100%;
		height: 100%;
	}

	.asset-name {
		display: block;
		margin-top: 8px;
		font-size: 12px;
		color: #374151;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.empty-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 60px 0;
		color: #9ca3af;
	}

	.empty-state i {
		font-size: 48px;
		margin-bottom: 16px;
	}

	::v-deep .el-dialog__body {
		max-height: 60vh;
		overflow-y: auto;
		padding: 20px 24px;
	}

	::v-deep .el-form-item {
		margin-bottom: 20px;
	}

	::v-deep .el-form-item__label {
		font-weight: 500;
		color: #374151;
		font-size: 14px;
	}



	::v-deep .el-dialog__footer {
		display: flex;
		justify-content: flex-end;
		gap: 12px;
		padding: 16px 24px;
	}

	::v-deep .el-dialog__header {
		padding: 20px 24px;
		border-bottom: 1px solid #e5e7eb;
	}

	::v-deep .el-dialog__title {
		font-size: 16px;
		font-weight: 600;
		color: #1f2937;
	}
</style>